export var usePlaceholder = function () {
    return {
        lastName: 'Ex : Martin',
        firstName: 'Ex : Camille',
        artistName: 'Ex : CamCam',
        email: 'Ex : camille@mail.com',
        password: '·······',
        profileTitle: 'Ex : Compositrice de musique classique',
        location: 'Ex : Paris, Lyon...',
        phone: 'Ex : 0600000000',
        social_instagram: 'Ex : https://www.instagram.com/...',
        social_facebook: 'Ex : https://www.facebook.com/...',
        social_linkedin: 'Ex : https://www.linkedin.com/...',
        social_twitter: 'Ex : https://twitter.com/...',
        social_malt: 'Ex : https://www.malt.fr/...',
        social_youtube: 'Ex: https://www.youtube.com/...',
        social_tiktok: 'Ex: https://www.tiktok.com/...',
        social_other: 'Ex: https://www.mon-porfolio.com/...',
        startYear: 'Année de début',
        endYear: 'Année de fin',
        company: 'Ex : Spotify',
        position: 'Ex : Manager',
        experienceDescription: 'À propos de cette expérience...',
        helpDescription: 'Indiquez votre question ou votre problème...',
    };
};
